<template>
    <div class="inline-block align-middle">
        <div class="truncate cursor-pointer text-white hover_text-gray-200 whitespace-no-wrap"
             @click.stop="$emit('update:popup', !popup)">
            <div class="inline-block align-middle">
                <div class="text-white" :class="{'font-bold': filtered && filtered.length > 0}">{{
                        text
                    }}
                </div>
                <div class="text-gray-300">{{ filtered }}</div>
            </div>
            <div class="inline-block align-middle px-2">
                <div class="sprite-icons-select-white"></div>
            </div>
        </div>
        <div class="absolute border shadow-md text-black bg-gray-100 z-10" v-if="popup" @click.stop="">
            <div class="border-b p-1">Filter by {{ text }}</div>
            <div class="p-2">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        popup: Boolean,
        filtered: [Object, String, Boolean]
    },
    created() {
        document.addEventListener('mousedown', this.outsideClick, true)
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.outsideClick)
    },
    methods: {
        outsideClick() {
            if (this.$el.contains(event.srcElement)) {
                return
            }
            this.$emit('update:popup', false)
        }
    }
}
</script>

